import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	style: { enableBackground: "new 0 0 32 32" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		id: "icon",
		cx: 16,
		cy: 16,
		r: 16
	}), /* @__PURE__ */ _jsx("polygon", {
		id: "X",
		points: "24.5,21.7 18.8,16 24.5,10.3 21.7,7.5 16,13.2 10.3,7.5 7.5,10.3 13.2,16 7.5,21.7 10.3,24.5 16,18.8 21.7,24.5 ",
		fill: "currentColor"
	})]
});
export default SvgClose;
